import { handleSaJobCategoryStatus, handleSaJobGet } from 'Actions/SuperAdmin/JobsAction';
import React, { Fragment } from 'react'
import { IoChevronBackCircle } from 'react-icons/io5';

const ApplicantFilter = ({
    glow, category,
    categoryChangingGlow, jobId,
    dispatch, pageRender,
    candidate_job_role,
    encrypted_job_id, job_status, basic_bestfit_generate
}) => {
    const jobCategries = ['All', 'Applied', 'Not Reviewed', 'Shortlisted', 'Rejected', 'Contacted', 'Hired', 'Recommended']

    return (
        <Fragment>
            {
                glow ?
                    <div className="row gy-2">
                        <div className="col-12 col-md-6 col-lg-2">
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 w-100 py-2"
                                onClick={() => pageRender("/super_admin/jobs")}>
                                <IoChevronBackCircle className="fs-5" /> Back
                            </button>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="placeholder w-100 pt-4 pb-3 rounded-3"></div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="placeholder w-100 pt-4 pb-3 rounded-3"></div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-2">
                            <div className="placeholder w-100 pt-4 pb-3 rounded-3"></div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-2">
                            <div className="placeholder w-100 pt-4 pb-3 rounded-3"></div>
                        </div>
                    </div>
                    :
                    <div className="row gy-2 align-items-end">
                        <div className="col-12 col-md-6 col-lg-2">
                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 w-100 py-2"
                                onClick={() => pageRender("/super_admin/jobs")}
                            >
                                <IoChevronBackCircle className="fs-5" /> Back
                            </button>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="dropdown employer-custom-dropdown">
                                <button
                                    id="applicantsCategoryButton"
                                    className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <span className="fw-bold">Category</span>
                                    <span className="text-secondary ps-3">
                                        {category === "Contacted" ? "Invited" : category}
                                    </span>
                                </button>

                                <ul className={`dropdown-menu w-100 border-0 shadow ${categoryChangingGlow ? 'pe-none dropdown-box-disable' : ''}`}>
                                    {
                                        jobCategries.map((v, i) => {
                                            return <li key={i}>
                                                <a
                                                    className={`dropdown-item dropdown-jobSort ${categoryChangingGlow ? 'pe-none dropdown-List-disable' : ''}`}
                                                    onClick={() => v === "All" ? dispatch(handleSaJobGet({ job_id: jobId, status: v })) : dispatch(handleSaJobCategoryStatus({ job_id: jobId, status: v }))}
                                                >
                                                    {v === "Contacted" ? "Invited" : v}
                                                </a>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="employer-custom-dropdown ">
                                <button
                                    className="btn w-100 d-flex align-items-center sa_role_btn choose-dropdown"
                                    type="button"
                                >
                                    <span className="fw-bold">Role</span>
                                    <span className="text-secondary text-truncate ps-3"
                                        style={{
                                            maxWidth: '80%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: 'inline-block'
                                        }}
                                    >
                                        {candidate_job_role}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-2">
                            <button type="button" className="btn btn-brand-color fs-15 rounded w-100 text-truncate"
                                style={{
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                                onClick={() => pageRender(`/super_admin/jobs/invited_applicants?id=${encrypted_job_id}`)}
                            >
                                Invited Applicants
                            </button>
                        </div>

                        <div className="col-12 col-md-6 col-lg-2">
                            <button type="button" className="btn btn-brand-color fs-15 rounded w-100 text-truncate"
                                style={{
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                                disabled={["paused", "closed"]?.includes(job_status?.toLowerCase())}
                                onClick={() => pageRender(`/super_admin/jobs/bestfit_applicants?id=${encrypted_job_id}&&status=${basic_bestfit_generate}`)}
                            >
                                <span className="me-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                        <path d="M11.9052 3.62712L13.9998 4.5004L14.8731 6.59501C14.8964 6.64181 14.9323 6.68119 14.9768 6.70871C15.0213 6.73623 15.0725 6.75081 15.1248 6.75081C15.1771 6.75081 15.2284 6.73623 15.2728 6.70871C15.3173 6.68119 15.3532 6.64181 15.3765 6.59501L16.2498 4.5004L18.3444 3.62712C18.3912 3.6038 18.4306 3.56788 18.4581 3.52342C18.4856 3.47895 18.5002 3.4277 18.5002 3.3754C18.5002 3.32311 18.4856 3.27185 18.4581 3.22739C18.4306 3.18292 18.3912 3.14701 18.3444 3.12368L16.2498 2.2504L15.3765 0.155794C15.3532 0.108992 15.3173 0.0696198 15.2728 0.0420993C15.2284 0.0145789 15.1771 0 15.1248 0C15.0725 0 15.0213 0.0145789 14.9768 0.0420993C14.9323 0.0696198 14.8964 0.108992 14.8731 0.155794L13.9998 2.2504L11.9052 3.12368C11.8584 3.14701 11.819 3.18292 11.7915 3.22739C11.764 3.27185 11.7494 3.32311 11.7494 3.3754C11.7494 3.4277 11.764 3.47895 11.7915 3.52342C11.819 3.56788 11.8584 3.6038 11.9052 3.62712ZM18.3444 14.3737L16.2498 13.5004L15.3765 11.4058C15.3532 11.359 15.3173 11.3196 15.2728 11.2921C15.2284 11.2646 15.1771 11.25 15.1248 11.25C15.0725 11.25 15.0213 11.2646 14.9768 11.2921C14.9323 11.3196 14.8964 11.359 14.8731 11.4058L13.9998 13.5004L11.9052 14.3737C11.8584 14.397 11.819 14.4329 11.7915 14.4774C11.764 14.5219 11.7494 14.5731 11.7494 14.6254C11.7494 14.6777 11.764 14.729 11.7915 14.7734C11.819 14.8179 11.8584 14.8538 11.9052 14.8771L13.9998 15.7504L14.8731 17.845C14.8964 17.8918 14.9323 17.9312 14.9768 17.9587C15.0213 17.9862 15.0725 18.0008 15.1248 18.0008C15.1771 18.0008 15.2284 17.9862 15.2728 17.9587C15.3173 17.9312 15.3532 17.8918 15.3765 17.845L16.2498 15.7504L18.3444 14.8771C18.3912 14.8538 18.4306 14.8179 18.4581 14.7734C18.4856 14.729 18.5002 14.6777 18.5002 14.6254C18.5002 14.5731 18.4856 14.5219 18.4581 14.4774C18.4306 14.4329 18.3912 14.397 18.3444 14.3737ZM13.9998 9.0004C13.9998 8.84364 13.9561 8.68998 13.8736 8.55665C13.7912 8.42333 13.6732 8.31562 13.5329 8.2456L9.84679 6.40271L8.00461 2.71693C7.71879 2.14564 6.78082 2.14564 6.495 2.71693L4.65246 6.40271L0.966677 8.2456C0.826456 8.31565 0.70852 8.42337 0.626091 8.55669C0.543662 8.69001 0.5 8.84366 0.5 9.0004C0.5 9.15715 0.543662 9.31079 0.626091 9.44411C0.70852 9.57744 0.826456 9.68516 0.966677 9.75521L4.65246 11.5981L6.495 15.2842C6.56505 15.4245 6.67277 15.5424 6.80609 15.6248C6.93941 15.7072 7.09306 15.7509 7.2498 15.7509C7.40655 15.7509 7.56019 15.7072 7.69351 15.6248C7.82683 15.5424 7.93456 15.4245 8.00461 15.2842L9.84679 11.5981L13.5329 9.75521C13.6732 9.68519 13.7912 9.57747 13.8736 9.44415C13.9561 9.31083 13.9998 9.15717 13.9998 9.0004ZM8.84168 10.2143C8.67813 10.296 8.5455 10.4285 8.46375 10.5919L7.2498 13.0198L6.03586 10.5919C5.9541 10.4285 5.82147 10.296 5.65793 10.2143L3.23004 9.0004L5.65793 7.78646C5.82142 7.70495 5.95404 7.57257 6.03586 7.40923L7.2498 4.98099L8.46375 7.40923C8.54556 7.57257 8.67818 7.70495 8.84168 7.78646L11.2696 9.0004L8.84168 10.2143Z" fill="white" />
                                    </svg>
                                </span>
                                Best Fit Candidates
                            </button>
                        </div>
                    </div>
            }
        </Fragment >
    )
}

export default ApplicantFilter